import * as M from "@radix-ui/react-dropdown-menu";
import clsx from "clsx";
import { Check } from "./icons";
import type { ComponentProps, ReactNode } from "react";
import s from "./Menu.module.css";

export const Menu = M.Root;
export const MenuTrigger = M.Trigger;
export const MenuRadioGroup = M.RadioGroup;

export function MenuContent({ className, align = "end", ...rest }: ComponentProps<typeof M.Content>) {
  return (
    <M.Portal>
      <M.Content className={clsx(s.content, className)} align={align} sideOffset={6} collisionPadding={8} {...rest} />
    </M.Portal>
  );
}

interface ItemExtras {
  icon?: ReactNode;
  shortcut?: string;
  danger?: boolean;
}

export function MenuItem({ icon, shortcut, danger, className, children, ...rest }: ComponentProps<typeof M.Item> & ItemExtras) {
  return (
    <M.Item className={clsx(s.item, danger && s.danger, className)} {...rest}>
      {icon && <span className={s.icon}>{icon}</span>}
      <span className={s.text}>{children}</span>
      {shortcut && <span className={s.shortcut}>{shortcut}</span>}
    </M.Item>
  );
}

export function MenuRadioItem({ icon, className, children, ...rest }: ComponentProps<typeof M.RadioItem> & Pick<ItemExtras, "icon">) {
  return (
    <M.RadioItem className={clsx(s.item, className)} {...rest}>
      {icon && <span className={s.icon}>{icon}</span>}
      <span className={s.text}>{children}</span>
      <M.ItemIndicator className={s.indicator}>
        <Check />
      </M.ItemIndicator>
    </M.RadioItem>
  );
}

export function MenuLabel({ className, ...rest }: ComponentProps<typeof M.Label>) {
  return <M.Label className={clsx(s.label, className)} {...rest} />;
}

export function MenuSeparator() {
  return <M.Separator className={s.separator} />;
}
